export default __webpack_public_path__ + "static/media/footlocker.2dfde785.png";